import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { getToken } from "../../utils/getToken";

export const useGetInventoryAllHistoryQuery = () => {
  const token = getToken();

  return useQuery({
    queryKey: ["getInventoryHistory"],
    queryFn: () =>
      axiosInstance
        .get("inventories", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => res.data),

    // onError: (error: any) => {
    //   message.error(error?.response?.data?.message || 'An error occurred');
    //   console.error('Error fetching inventory history:', error);
    // },
    enabled: !!token,
  });
};
